import React from 'react';

class DialogCommissionsField extends React.Component {
    render() {
        return (
            <div>
        
            </div>
        );
    }
}

export default DialogCommissionsField;